import { ScanLogActionDto, ScanLogDto, ScanLogUserDto } from './scan-log.dto';

export class ScanLogUser {
    readonly id: string | null;
    readonly label: string;

    constructor(dto: ScanLogUserDto) {
        this.id = dto.id;
        this.label = dto.label ?? '';
    }
}

export class ScanLogAction {
    readonly value: string;
    readonly label: string;
    readonly group: string;

    constructor(dto: ScanLogActionDto) {
        this.value = dto.value;
        this.label = dto.label;
        this.group = dto.group;
    }
}

export class ScanLog {
    readonly id: string;
    readonly createdAt: Date;
    readonly user: ScanLogUser;
    readonly station: string;
    readonly action: ScanLogAction;
    readonly details: string;

    constructor(dto: ScanLogDto) {
        this.id = dto.id;
        this.createdAt = new Date(dto.createdAt);
        this.user = new ScanLogUser(dto.user);
        this.station = dto.station ?? '';
        this.action = new ScanLogAction(dto.action);
        this.details = dto.details;
    }
}
